import { createStore } from 'vuex'
import auth from '@/store/modules/auth'
import orders from '@/store/modules/orders'
import recipients from '@/store/modules/recipients'
import address from '@/store/modules/address'
import balance from "@/store/modules/balance"
import comments from '@/store/modules/comments'
import products_viewed from '@/store/modules/products_viewed'
import products_wishlist from "@/store/modules/products_wishlist";
import cart from "@/store/modules/cart";

// Create a new store instance.
export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    orders,
    recipients,
    address,
    balance,
    comments,
    products_viewed,
    products_wishlist,
    cart,
  }
})
